module.exports = __webpack_public_path__ + "img/832.f59be072.png";